import { render, staticRenderFns } from "./HeaderMore.vue?vue&type=template&id=b4728594&scoped=true&"
import script from "./HeaderMore.vue?vue&type=script&lang=js&"
export * from "./HeaderMore.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMore.vue?vue&type=style&index=0&id=b4728594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4728594",
  null
  
)

export default component.exports